const clipboardMixin = {
  methods: {
    copyTextToClipboard(text) {
      let success = false;

      const textArea = document.createElement('textarea');
      textArea.value = text;

      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';

      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        success = true;
      } catch (err) {
        success = false;
      }

      document.body.removeChild(textArea);

      return success;
    },
  },
};

export default clipboardMixin;
